import React from "react"
import styled from "styled-components"
import Background from "./Background"
import Title from "./Title"
import { useHeaderOverWrapped } from "../../hooks/index"
const StyledHeadWrapper = styled.div`
  position: relative;
  height: 300px;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 500px) {
    height: 240px;
  }
`

export default function MainVisualWithCassis({
  title,
  subTitle = [],
  mainVisualSrcset = undefined,
  bgColor = undefined,
}) {
  const { ref } = useHeaderOverWrapped({})
  return (
    <StyledHeadWrapper ref={ref}>
      <Background mainVisualSrcset={mainVisualSrcset} bgColor={bgColor} />
      <Title title={title} subTitle={subTitle} />
    </StyledHeadWrapper>
  )
}
